import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Box,
  Button,
  useMedia,
  VerticalSpacing,
} from '../../components/Boneyard';
import { hook, withValue } from '@g4/automation-hooks';
import { useSSRQuery } from '../../graphql';

import tracking from '@g4/g4-analytics';

import { MERCH_SPOT_BANNER } from '../../../automationHooks.json';
import MERCHANDISE_SPOT_BANNER_QUERY from './merchandiseSpotBanner/merchandiseSpotBanner.graphql.js';

const BannerImage = styled.img`
  width: 100%;
  max-width: 600px;

  ${props => props.theme.query.md} {
    max-width: none;
  }
`;

const MerchandiseSpotBanner = () => {
  const mq = useMedia();
  const isMobile = mq.lte('sm');

  const { loading, data, error } = useSSRQuery(MERCHANDISE_SPOT_BANNER_QUERY);
  const spotBanner = data?.application?.merchandiseSpotBanner;
  const desktopImage = spotBanner?.desktopImage?.image;
  const mobileImage = spotBanner?.responsiveImage?.image;

  useEffect(() => {
    if (!loading && data && spotBanner) {
      const creativeInfo = !isMobile
        ? desktopImage?.split('/').slice(-1)[0]
        : mobileImage?.split('/').slice(-1)[0];
      const promoData = {
        name: 'Merchandise Spot Banner',
        creative: creativeInfo,
        position: 'Home Page',
      };
      tracking.trackPromoImpressionExternal(promoData);
    }
  }, [data, loading, spotBanner, isMobile, desktopImage, mobileImage]);

  if (loading) {
    return null;
  }

  if (!spotBanner) {
    return null;
  }

  if (error) {
    console.log(error);
    return null;
  }

  const handleClick = () => {
    const creativeInfo = !isMobile
      ? desktopImage?.split('/').slice(-1)[0]
      : mobileImage?.split('/').slice(-1)[0];
    const promoData = {
      name: 'Merchandise Spot Banner',
      creative: creativeInfo,
      position: 'Home Page',
    };
    tracking.trackPromoClickExternal(promoData);
  };

  return (
    <React.Fragment>
      <Box
        d="flex"
        direction={'column'}
        automationHook={MERCH_SPOT_BANNER.hook}
        pt={6}
        pb={6}
        alignItems="center"
      >
        <BannerImage
          src={!isMobile ? desktopImage : mobileImage}
          alt={
            !isMobile
              ? spotBanner.desktopImage.alternateText
              : spotBanner.responsiveImage.alternateText
          }
          {...hook(
            MERCH_SPOT_BANNER.hook,
            !isMobile ? 'desktop-image' : 'responsive-image'
          )}
        />
        <VerticalSpacing size={3} />
        {spotBanner.clickThrough && (
          <Box w={isMobile ? '100%' : '200px'} zIndex={0}>
            <Button
              automationHook={withValue(MERCH_SPOT_BANNER.hook, 'button')}
              href={spotBanner.clickThrough.url}
              target={
                spotBanner.clickThrough.target
                  ? `_${spotBanner.clickThrough.target.toLowerCase()}`
                  : '_blank'
              }
              type="primary"
              as="a"
              onClick={handleClick}
              fullWidth
            >
              {spotBanner.clickThrough.title
                ? spotBanner.clickThrough.title
                : 'Learn More'}
            </Button>
          </Box>
        )}
      </Box>
      <VerticalSpacing size={5} />
    </React.Fragment>
  );
};

MerchandiseSpotBanner.propTypes = {
  desktopImage: PropTypes.string,
  responsiveImage: PropTypes.string,
};

export default MerchandiseSpotBanner;
